const mInitialSetup = {
  mInitialSetup: {
  }
}

export default mInitialSetup
